import { useToast } from '@solfacil/girassol'
import { useMutation } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { getReceiptPdf } from '~/services-v2/payment-model-api/payment-model-api'

export default function useDownloadReceipt(projectId: Ref<string>) {
  const toast = useToast()

  const filenameMap: Record<string, string> = {
    after_project_formalization: 'pagamento-financiamento-apos-formalizacao',
    after_validation_installation: 'pagamento-financiamento-apos-instalacao',
    equipment: 'do-equipamento',
    commission_financing: 'de-comissao-financiamento',
    commission_insurance: 'de-comissao-seguro',
  }

  const mutationKey = queryKeys.PAYMENT_MODEL.DOWNLOAD_RECEIPT(projectId.value)

  const mutationFn = async (item: any) => {
    const response = await getReceiptPdf(item.id)

    // Decode base64 string to binary
    const { base64, type } = response
    const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0))
    const blob = new Blob([bytes], { type: type || 'application/pdf' })

    // create a link element
    const link = document.createElement('a')
    const nameFile = filenameMap[item.category !== 'financing' ? item.category : item.kind]
    link.href = URL.createObjectURL(blob)
    link.download = `comprovante-${nameFile}.pdf`
    link.click()
    URL.revokeObjectURL(link.href)

    return response
  }

  const query = useMutation({
    mutationFn,
    mutationKey,
    onSuccess: () => {
      toast.createSuccessToast({ title: 'Comprovante baixado com sucesso', description: ' O comprovante foi baixado com sucesso. Você pode encontrá-lo na pasta de downloads do seu computador.' })
    },
    onError: (error) => {
      toast.createErrorToast({ title: 'Erro ao baixar o comprovante', description: 'Ocorreu um erro ao tentar baixar o comprovante. Tente novamente mais tarde.' })
      console.error('Error downloading receipt:', error)
    },
  })

  return query
}
